import { Record } from "immutable";

import { UserModel } from "./UserModel";

const defaults = {
  createdAt: new Date(0),
  creator: null as null | UserModel,
  creatorId: "",
  deletedAt: null as Date | null,
  expiresAt: null as Date | null,
  id: "",
  lastUsedAt: null as Date | null,
  name: "",
  value: "",
};

export class ApiTokenModel extends Record<typeof defaults>(defaults) {
  get isRevoked() {
    return this.deletedAt !== null;
  }

  static fromServerData(data: unknown) {
    const { createdAt, creator, creatorId, deletedAt, expiresAt, id, lastUsedAt, name, value } = data as typeof defaults;
    return new ApiTokenModel({
      createdAt: new Date(createdAt),
      creator: creator ? UserModel.fromServerData(creator) : null,
      creatorId,
      deletedAt: deletedAt ? new Date(deletedAt) : null,
      expiresAt: expiresAt ? new Date(expiresAt) : null,
      id,
      lastUsedAt: lastUsedAt ? new Date(lastUsedAt) : null,
      name,
      value,
    });
  }
}
